import { render, staticRenderFns } from "./ServicesCat.vue?vue&type=template&id=6d491ba3"
import script from "./ServicesCat.vue?vue&type=script&lang=js"
export * from "./ServicesCat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports